module.exports = __webpack_public_path__ + "img/fontello.061ca6d.svg";